import React from 'react';
import './RightBlock.css';

function RightBlock({ imgUrl }) {
  return (
    <div className="sign-in-right flex-grow w-1/2 relative hidden lg:block h-full">
      <div className="w-full h-full relative right-block">
        <img
          src={imgUrl}
          className="object-cover w-full h-screen right-block"
          alt="Sign in"
        />
      </div>
    </div>
  );
}

RightBlock.defaultProps = {
  imgUrl:
    'https://cdn.pixabay.com/photo/2016/02/29/15/02/doctor-1228629_1280.jpg',
};

export default RightBlock;
